import { render, staticRenderFns } from "./business_index.vue?vue&type=template&id=6ae03340&scoped=true&"
import script from "./business_index.vue?vue&type=script&lang=js&"
export * from "./business_index.vue?vue&type=script&lang=js&"
import style0 from "./business_index.vue?vue&type=style&index=0&id=6ae03340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae03340",
  null
  
)

export default component.exports